import { render, staticRenderFns } from "./ImpactBadgeColumn.vue?vue&type=template&id=36b8bf2f&scoped=true"
import script from "./ImpactBadgeColumn.vue?vue&type=script&lang=js"
export * from "./ImpactBadgeColumn.vue?vue&type=script&lang=js"
import style0 from "./ImpactBadgeColumn.vue?vue&type=style&index=0&id=36b8bf2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8bf2f",
  null
  
)

export default component.exports